module.exports = __webpack_public_path__ + "static/media/office_1@2x.3d350b5a.jpg";